import * as ReactDOM from "react-dom";
const legacyReactRenderer = (domElement, reactElement) => ReactDOM.render(reactElement, domElement);
export {
  legacyReactRenderer
};
//# sourceMappingURL=render.js.map
